module.exports = __webpack_public_path__ + "img/MpcEnergyView.e4299e94.png";